// extracted by mini-css-extract-plugin
module.exports = {"resultList":"eventSearchPage_resultList__ICX_r","spinner":"eventSearchPage_spinner__chHZ9"};